import { helper as buildHelper } from '@ember/component/helper';

export default buildHelper(([num1, num2]) => {
  return num1 - num2;
});
